import React from 'react';
// import ReactDOM from 'react-dom';
// import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import { GlobalTheme, Theme } from '@carbon/react';
import './App.scss';
import { BrowserRouter } from 'react-router-dom';

// import CssBaseline from '@mui/material/CssBaseline';
// import { ThemeProvider } from '@mui/material/styles';
// import theme from './theme';

const container = document.getElementById('root');

const root = createRoot(container); // createRoot(container!) if you use TypeScript


root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <GlobalTheme theme="g100">
          <Theme theme="g100">
            <App />
          </Theme>
        </GlobalTheme>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
